// extracted by mini-css-extract-plugin
export default {"mobileHowItWorksContainer":"SimplifiedMobileHowItWorksSection_mobileHowItWorksContainer__4DrNL","howItWorksHeadline":"SimplifiedMobileHowItWorksSection_howItWorksHeadline__7hAmF"};